import http from './http-common';

class GoalAlignmentService {

    // http://localhost:5000/api/v1/scoreboard/goal-alignment/add
    add(data) {
        const path = '/scoreboard/goal-alignment';
        console.log('data: ', data);
        return http.post(`${path}/add`, data);
    };

    // http://localhost:5000/api/v1/scoreboard/goal-alignment/get/:id
    getByClientId(clientId) {
        const path = '/scoreboard/goal-alignment';
        return http.get(`${path}/get/${clientId}`);
    };

    // http://localhost:5000/api/v1/scoreboard/goal-alignment/get/:id
    update(data, id) {
        const path = '/scoreboard/goal-alignment';
        return http.put(`${path}/update/${id}`, data);
    }


}

export default new GoalAlignmentService();
